<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'sidebar-item',
})
</script>
<template>
  <ul class="maia-custom-menu">
    <template
      v-for="item of permissionRoutes"
      :key="item.path"
    >
      <li
        v-if="!item.hidden"
        class="maia-menu-item-wrap"
      >
        <section
          v-if="item.disabled"
          class="maia-menu-item disabled"
        >
          <base-svg-icon
            style="width: 30px; height: 30px;color: #FF0;"
            :icon-class="`icon-${item.icon}`"
          />
          <p class="maia-menu-item__title">{{ item.title }}</p>
        </section>
        <section
          v-else-if="item.blank"
          :class="[
            'maia-menu-item',
            'blank',
            item.path === activeMenu ? 'is-active' : ''
          ]"
          @click="handleBlank(item)"
        >
          <base-svg-icon
            style="width: 30px; height: 30px;"
            :icon-class="`icon-${item.icon}`"
          />
          <p class="maia-menu-item__title">{{ item.title }}</p>
        </section>
        <app-link
          v-else
          :class="[
            'maia-menu-item',
            item.path === activeMenu ? 'is-active' : ''
          ]"
          :to="resolvePath(item)"
          :is-blank="item.isBlank"
          @click="showCollapse(item.path === activeMenu)"
        >
          <base-svg-icon
            v-if="item.path === activeMenu"
            style="width: 30px; height: 30px;color: #FF0;"
            :icon-class="`icon-${item.icon}-active`"
          />
          <base-svg-icon
            v-else
            style="width: 30px; height: 30px;color: #FF0;"
            :icon-class="`icon-${item.icon}`"
          />

          <p class="maia-menu-item__title">{{ item.title }}</p>
        </app-link>
      </li>
    </template>
  </ul>
</template>
<script lang="ts" setup name="sidebar-item">
  import AppLink from './sidebar-link.vue';

  defineProps({
    permissionRoutes: {
      type: Array<any>,
      default: [],
    },
    activeMenu: {
      type: String,
      default: '',
    },
  });
  const emit = defineEmits(['setCollapse', 'to-blank']);

  const resolvePath = (routeInfo: TypeObject): string => {
    if (routeInfo.children && routeInfo.children.length) {
      const validChildren = routeInfo.children.filter((item: TypeObject) => !item?.meta?.hidden && !item.disabled);
      if (validChildren.length > 0) {
        return resolvePath(validChildren[0]);
      }
    }
    return routeInfo.path;
  };

  const showCollapse = (val:boolean) => {
    emit('setCollapse', val);
  };

  /*
   * const resolvePath = (routeInfo:TypeObject): string => {
   *   if (routeInfo.children && routeInfo.children.length) {
   *     // return routeInfo.children.filter((item:TypeObject) => !item.hidden && !item.disabled)[0]?.path;
   *     const temp = routeInfo.children.filter((item:TypeObject) => !item.hidden && !item.disabled);
   *     console.log(temp);
   *     if (temp[0].children && temp[0].children.length) {
   *       return temp[0].children.filter((item:TypeObject) => !item.hidden && !item.disabled)[0]?.path;
   *     }
   *     return temp[0]?.path;
   *   }
   *   return routeInfo.path;
   * };
   */

  const handleBlank = (info:TypeObject) => {
    if (info.targetUrl) {
      window.open(info.targetUrl, '_blank');
    } else {
      emit('to-blank', info);
    }
  };
</script>
<style lang="scss" scoped>
.maia-custom-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
  height: calc(100vh - 200px);
  color: var(--maia-menu-text-color);

  .maia-menu-item-wrap {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60px;
    margin: 10px 0;
    padding: 0 2px;

    .maia-menu-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 100%;
      padding: 0 var(--maia-base-space);
      color: #748393;
      font-weight: 400;
      font-size: 18px;

      /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
      font-family: YouSheBiaoTiHei;
      white-space: nowrap;

      p{
        margin-top: 6px;
      }

      &.disabled {
        // color: var(--ma-text-color-disabled);
        cursor: no-drop;
      }

      &.blank {
        cursor: pointer;
      }

      &.is-active {
        color: rgba(17, 104, 255, 1);
      }
    }
  }
}
</style>
